import React from 'react'
import { Text, Button } from '@deseretbook/react-ui'
import propTypes from 'prop-types'

/**
 * Read now button with plus icon
 *
 * @param {string} url - Link to read or listen to media
 * @param {string} actionText - Text to display on the button
 * @returns {function} react component
 */
const ActNowButton = ({ isPlus, isFree, isAudiobook, buttonProps, isVip, purchased, ...rest }) => {
  const actionText = isAudiobook ? 'Listen' : 'Read'

  let buttonColor = 'bookshelf'

  if (!purchased && !isFree) {
    if (isVip) {
      buttonColor = 'vip'
    } else if (isPlus) {
      buttonColor = 'plus'
    }
  }

  const defaultButtonProps = {
    isFullwidth: true,
    color: buttonColor,
    style: {
      marginTop: '1rem',
      color: 'white',
    },
  }

  return (
    <Button
      {...defaultButtonProps}
      {...buttonProps}
      style={{
        minWidth: '10rem',
        width: '10rem',
        borderRadius: '26px',
        padding: '1rem 28px',
        border: 'none',
      }}
      {...rest}
    >
      <Text
        style={{
          fontFamily: 'Roboto, sans-serif',
          fontWeight: 700,
          fontSize: '16px',
          lineHeight: '18.75px',
          color: buttonColor === 'vip' ? 'white' : 'black',
        }}
      >
        {`${actionText} Now`}
      </Text>
    </Button>
  )
}

ActNowButton.defaultProps = {
  isPlus: false,
  isVip: false,
  isFree: false,
  isAudiobook: false,
  buttonProps: {},
  purchased: false,
}

ActNowButton.propTypes = {
  purchased: propTypes.bool,
  isPlus: propTypes.bool,
  isVip: propTypes.bool,
  isFree: propTypes.bool,
  isAudiobook: propTypes.bool,
  buttonProps: propTypes.shape({}),
}

export default ActNowButton
